import { render, staticRenderFns } from "./CheckoutDesc.vue?vue&type=template&id=d8d55c6a&scoped=true"
import script from "./CheckoutDesc.vue?vue&type=script&lang=js"
export * from "./CheckoutDesc.vue?vue&type=script&lang=js"
import style0 from "./CheckoutDesc.vue?vue&type=style&index=0&id=d8d55c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d55c6a",
  null
  
)

export default component.exports